import { useQuery } from '@apollo/client';
import { WEB_PAGE_QUERY } from '../graphql/webPage';

export default function useTrainer() {
  const url = window.location.href;
  return useQuery(WEB_PAGE_QUERY, { variables: { url } });
}
